import { render, staticRenderFns } from "./VisitorBlocked.vue?vue&type=template&id=d654bbf2&scoped=true"
import script from "./VisitorBlocked.vue?vue&type=script&lang=js"
export * from "./VisitorBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d654bbf2",
  null
  
)

export default component.exports